import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-3" }

import { ref, defineAsyncComponent } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'indexUserManagement',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const SupportTable = defineAsyncComponent(() => import("@/components/theme/users_management/UserMTable.vue"))

let desc = ref<string>("List Of User Accounts");

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "users_management/createuser"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", { "data-feather": "plus-square" }, null, -1),
            _createTextVNode(" Create New User ")
          ])),
          _: 1
        })
      ]),
      _createVNode(_unref(Card3), {
        colClass: "col-sm-12",
        title: "Users Management Overview",
        headerTitle: "true",
        cardhaderClass: "title-header",
        text: "true",
        desc: _unref(desc),
        btnclass: 'btn-primary'
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SupportTable))
        ]),
        _: 1
      }, 8, ["desc"])
    ])
  ]))
}
}

})